import {
    emailValidation,
    limitValidation,
    phoneNumberValidation,
    requiredValidation
} from "../../../../core/components/forms/Validation";
import {ORDER_FILE_LIMIT} from "../../../../core/constants/FileLimitConstant";

export const required = requiredValidation();
export const requiredFiles = requiredValidation('No files added.');
export const maxFiles = limitValidation(ORDER_FILE_LIMIT)('Added too many files, max count is '+ORDER_FILE_LIMIT+'.');
export const email = emailValidation();
export const phone = phoneNumberValidation();